import { map } from 'lodash'
import ModifierGroupViewModel from './ModifierGroupViewModel'

const ModifierGroupsViewModel = (modifierGroups) => {
  return map(modifierGroups, ModifierGroupViewModel)
}

export default ModifierGroupsViewModel
